import { render, staticRenderFns } from "./BranchTable.vue?vue&type=template&id=554f3877&scoped=true&"
import script from "./BranchTable.vue?vue&type=script&lang=js&"
export * from "./BranchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f3877",
  null
  
)

export default component.exports